<template>
  <b-modal :id="modalId" class="modal-about"
    hide-footer size="sm" header-class="modal-about-header">
    <div v-if="isRebranding" slot="modal-title">
      <img :src="require('../../assets/goto-logo.svg')" /> GoTo Webinar
    </div>
    <div v-else slot="modal-title">
      <img :src="require('../../assets/g2w-logo.svg')" /> GoToWebinar
    </div>
    <p>
      Version {{ displayVersion }}
    </p>
    <p style="font-size: .8em">
      Built on {{ buildDate.toLocaleString('en', {timeZone: 'UTC'}) }} UTC
    </p>
  </b-modal>
</template>

<script>
const ModalAbout = {
  name: 'ModalAbout',

  props: ['modalId'],

  data() {
    return {
      buildDate: new Date(BUILD_DATE)
    };
  },

  computed: {
    displayVersion() {
      // if (DEVELOPMENT)
      return `${VERSION}-${COMMITHASH.slice(0, 7)}`;
    },

    isRebranding() {
      return this.$store.state.features.isRebranding;
    },
  }
};

export default ModalAbout;
</script>

<style lang="sass">
  .modal-about
    .modal-about-header
      border-bottom: none
</style>
